import React from 'react';

import Modal from './Modal';
import ShortButton from 'components/Button/ShortButton';
import Field from 'components/Field/Field';
import Text from 'components/Text/Text';
import Input from 'components/Input/Input';
import InputArea from 'components/Input/InputArea';

const ButtonArea = (dialogType, confirm, cancel) => {
  switch(dialogType) {
    case('IWSConfirm'):
      return(
        <Field style={{ paddingTop: '32px', justifyContent: 'space-around' }} inline>
          <ShortButton style={{ width: '155px', height: '51px' }} onClick={cancel} secondary>NO</ShortButton>
          <ShortButton autoFocus style={{ width: '155px', height: '51px' }} onClick={confirm}>YES</ShortButton>
        </Field>
      );
    default:
      return(
        <Field style={{ paddingTop: '32px' }} rightAlign>
          <ShortButton style={{ marginRight: '16px' }} onClick={cancel} secondary>CANCEL</ShortButton>
          <ShortButton autoFocus onClick={confirm}>OK</ShortButton>
        </Field>
      );
  }
}

export default class ConfirmationDialog extends React.Component {
  constructor(props) {
    super();

    this.state = {
      value: props.value
    };
  }
  componentDidMount() {
    this.input && this.input.select && this.input.select();
  }
  handleKeyUp = (e) => {
    switch (e.which) {
      case 13: // Enter
        e.stopPropagation();
        return this.confirm();
      default:
        return;
    }
  };
  confirm = () => {
    this.props.confirm(this.state.value);
  };
  cancel = () => {
    this.props.cancel();
  };
  render() {
    return (
      <Modal onKeyUp={this.handleKeyUp} style={{ maxWidth: !this.props.type ? '640px' : 'unset', width: this.props.longInput ? '100%' : 'unset' }}>
        {this.props.type ? 
          this.props.message 
          : 
          <Field style={{ paddingTop: 0 }}>
            <Text>{this.props.message}</Text>
          </Field>}
        {this.props.input && (
          <Field>
            {this.props.area ? (
              <InputArea ref={r => this.input = r} onKeyUp={e => e.which === 13 && e.stopPropagation()} value={this.state.value} onChange={({ target: { value } }) => this.setState({ value })} />
            ) : (
              <Input ref={r => this.input = r} value={this.state.value} onChange={({ target: { value } }) => this.setState({ value })} />
            )}
          </Field>
        )}
        {ButtonArea(this.props.type, this.confirm, this.cancel)}
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modals/ConfirmationDialog.js